export default "__VITE_ASSET__BJJMlY1O__"